import React from 'react';
import { StrategyState } from '../services/api';

const STATE_STYLES: Record<StrategyState, string> = {
  DRAFT:          'bg-gray-100 text-gray-600',
  SUBMITTED:      'bg-blue-100 text-blue-700',
  OUTPUT_READY:   'bg-amber-100 text-amber-700',
  LIVE:           'bg-green-100 text-green-700',
  EDIT_REQUESTED: 'bg-orange-100 text-orange-700',
  UPLOAD_FAILED:  'bg-red-100 text-red-700',
  INACTIVE:       'bg-gray-200 text-gray-500',
};

const STATE_LABELS: Record<StrategyState, string> = {
  DRAFT:          'Draft',
  SUBMITTED:      'Submitted',
  OUTPUT_READY:   'Output Ready',
  LIVE:           'Live',
  EDIT_REQUESTED: 'Edit Requested',
  UPLOAD_FAILED:  'Upload Failed',
  INACTIVE:       'Inactive',
};

export default function StrategyStateBadge({ state }: { state: StrategyState }) {
  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${STATE_STYLES[state] ?? 'bg-gray-100 text-gray-600'}`}
    >
      {STATE_LABELS[state] ?? state}
    </span>
  );
}
